import React, { useState } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import logo from "../../../../assets/images/logo.png";
import { useMountEffect } from "primereact/hooks";
import StorageHelper from "../../../../utils/storage-helper";

export default function CustomerMenu() {
  const location = useLocation();
  const history = useHistory();
  const currentPath = location.pathname;
  const isActiveUrl = (url) =>
    url === "/" ? currentPath === "/" : currentPath.startsWith(url);

  const items = [
    { label: "Home", url: "/", icon: "pi pi-home" },
    { label: "Manage Policy", url: "/manage-policy", icon: "pi pi-shield" },
    { label: "Manage Payments", url: "/payments", icon: "pi pi-credit-card" },
    { label: "Manage Loans", url: "/loans", icon: "pi pi-wallet" },
    { label: "Manage Claims", url: "/claims", icon: "pi pi-file" },
  ];

  const [fullName, setFullName] = useState("");
  const [initialsName, setInitialsName] = useState("");
  useMountEffect(() => {
    const fetchUserRole = async () => {
      try {
        const firstName = StorageHelper.get("firstName", "") || "";
        const lastName = StorageHelper.get("lastName", "") || "";
        if (firstName || lastName) {
            setInitialsName(`${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase());
            setFullName(`${firstName} ${lastName}`.trim());
        }
      } catch (error) {
        console.error("Error fetching user role:", error);
      }
    };
    fetchUserRole();
  });

  const handleLogout = () => {
      StorageHelper.remove("token");
      history.push("/signin");
  };

  return (
    <div className="fixed top-4 left-0 w-full z-50 flex justify-center px-4">
      {/* Container: Bulletproof flex row */}
      <div className="bg-base-100 shadow-sm hover:shadow-md rounded-full border border-base-200 w-full max-w-6xl px-6 h-16 flex flex-row items-center justify-between">
        
        {/* Left Side: Logo & Mobile Menu */}
        <div className="flex items-center gap-4">
          <div className="dropdown lg:hidden">
            <button type="button" className="btn btn-ghost btn-circle">
              <svg aria-label="Menu" xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"> 
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /> 
              </svg>
            </button>
            <ul role="menu" tabIndex={0} className="menu menu-sm dropdown-content bg-base-100 rounded-box z-[1] mt-3 w-52 p-2 shadow-sm border border-base-200">
              {items.map((item) => (
                <li key={item.url}>
                  <Link to={item.url} className={isActiveUrl(item.url) ? "bg-blue-50 text-primary font-semibold" : ""}>
                    <i className={`${item.icon} mr-2`}></i>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <Link to="/" className="hover:opacity-80 transition-opacity">
            <img alt="logo" src={logo} className="h-10 w-auto object-contain block" />
          </Link>
        </div>

        {/* Center: Desktop Links */}
        <div className="hidden lg:flex flex-row items-center gap-1">
            {items.map((item) => (
              <Link 
                  key={item.url}
                  to={item.url} 
                  className={`rounded-full px-4 py-2 flex items-center gap-2 transition-colors ${isActiveUrl(item.url) ? "bg-blue-50 text-primary font-bold" : "text-gray-600 hover:bg-base-200 font-semibold"}`}
              >
                <i className={`${item.icon} text-lg`}></i>
                {item.label}
              </Link>
            ))}
        </div>

        {/* Right Side: Avatar */}
        <div className="flex items-center">
          <div className="dropdown dropdown-end">
            <button type="button" className="btn btn-circle btn-primary text-white font-bold border-none hover:brightness-110">
              {initialsName || "U"}
            </button>
            <ul role="menu" tabIndex={0} className="menu dropdown-content z-[1] mt-3 w-52 rounded-box bg-base-100 p-2 shadow-sm border border-base-200">
              <li className="menu-title px-4 py-2">
                <span className="font-semibold text-gray-800">{fullName || "Account"}</span>
              </li>
              <li><Link to="/reset">Change Password</Link></li>
              <li><button onClick={handleLogout} className="text-red-500">Logout</button></li>
            </ul>
          </div>
        </div>

      </div>
    </div>
  );
}
